// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__LXpGR","productName":"Table_productName__wkDFg"};